import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';
import { CONTACT } from '@common/constants';

import { FireRiskAssessment } from '@modules/services/fireRiskAssessment/FireRiskAssessment';

const TITLE = 'Comprehensive Fire Risk Assessment in London | Qeeper';
const DESC = `Fire safety services for your home and properties. Fire risk assessment and fire safety equipment installation and maintenance in London.  ${CONTACT.PHONE}`;
const URL = 'https://www.qeeper.co.uk/services/fire-risk-assessment';
const SEO_KEYWORDS =
  'fire protection services, fire security, fire safety london, fire solutions';

const FireRiskAssessmentPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <FireRiskAssessment />
    </>
  );
};

export default FireRiskAssessmentPage;
